import { P2GGrid } from '@parcel2go/core-ui';

import { ApplierOption } from '../../../lib/helpers/ApplierOption';
import ActionIcon from './ActionIcon';
import { GetBulkActionIcon, GetBulkActionIconSrc } from './GetBulkActionIcon';
import { GetBulkActionTitle } from './GetBulkActionTitle';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  action: ApplierOption;
  onClick?: (a: ApplierOption) => void;
  bulkOptions?: ApplierOption[];
  label?: string;
  show?: boolean;
}

const BulkActionButton: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  if (props.bulkOptions && !props.bulkOptions.includes(props.action) && !props.show) {
    return null;
  }
  return (
    <P2GGrid item flexGrow={1}>
      <ActionIcon
        onClick={() => props.onClick(props.action)}
        count={props.bulkOptions ? props.bulkOptions.filter((x) => x === props.action).length : null}
        text={props.label || GetBulkActionTitle(t, props.action)}
        icon={GetBulkActionIcon(props.action)}
        iconSrc={GetBulkActionIconSrc(props.action)}
      />
    </P2GGrid>
  );
};

export default BulkActionButton;
